import React, { useEffect } from 'react'
import Gmail from './assets/images/gmail.png'
import LinkedIn from './assets/images/linkedin.png'
import Logo from "./assets/images/logo.webp";
import { NavLink } from "react-router-dom";

const ProductPageFooter = () => {
    
const path = window.location.pathname;
const getBackgroundColor = () => {
    if (path.includes('ecom-project')) return '#FFF2EE';
    if (path.includes('divido-project')) return '#FFFDE5';
    if (path.includes('pixel-project')) return '#EFF3FF';
    if (path.includes('igniteai-project')) return '#F2FFEF';
    return '#FFFFFF';
};

const [BackgroundColor, setBackgroundColor] = React.useState(getBackgroundColor());

useEffect(() => {
    setBackgroundColor(getBackgroundColor());
}, [path]);
  return (
    <>
    <section className="footer py-5 mt-5" style={{ backgroundColor: BackgroundColor }}>
       <div className="container">
        <div className="row align-items-center">
            <div className="col-md-7 my-2">
               <div className="footer-content py-5">
               <h2 className="fs-64 mb-3 tanks-msg">Thanks for your Time!</h2>
                <div className="d-flex gap-3 justify-content-center mt-5">
                    <div className="foot-icons">
                        <a href="mailto:hovarthini@gmail.com" target="_blank" rel="noopener noreferrer">
                        <img src={Gmail} alt="Gmail Icon" />
                        </a>
                    </div>
                    <div className="foot-icons">
                        <a href="https://linkedin.com/in/hovarthini/" target="_blank" rel="noopener noreferrer">
                        <img src={LinkedIn} alt="Gmail Icon" />
                        </a>
                    </div>
                </div>
               </div>
            </div>
            <div className="col-md-5 my-3">
            <a className="navbar-brand d-block " href="#">
                    <div className="logo-img ms-lg-auto mx-auto">
                    <NavLink to={'/'}>
                        <img className="img-contain" src={Logo} alt="Logo" />
                               
                            </NavLink>
                    </div>
                </a>
            </div>
        </div>
       </div>
    </section>
    </>
  )
}

export default ProductPageFooter